export enum CaseStatusEnum {
  Created = 'Created',
  SentInvestor = 'SentInvestor',
  ApprovedInvestor = 'ApprovedInvestor',
  DeclinedInvestor = 'DeclinedInvestor',
  SignedInvestor = 'SignedInvestor',
  SentAdministrator = 'SentAdministrator',
  SignedAdministrator = 'SignedAdministrator',
  SentAllOwners = 'SentAllOwners',
  SentLessee = 'SentLessee',
  ReceivedLessee = 'ReceivedLessee',
  SignedLessee = 'SignedLessee',
  DeclinedLessee = 'DeclinedLessee',
  SentOwner = 'SentOwner',
  ReceivedOwner = 'ReceivedOwner',
  SignedOwner = 'SignedOwner',
  DeclinedOwner = 'DeclinedOwner',
  SignedAllOwners = 'SignedAllOwners',
  HandedOverInvestor = 'HandedOverInvestor',
  AuctionWin = 'AuctionWin',
  ExpropriationProposal = 'ExpropriationProposal',
  ExpropriationAssessmentInterupted = 'ExpropriationAssessmentInterupted',
  ExpropriationCalledHearing = 'ExpropriationCalledHearing',
  ExpropriationHearingRepetition = 'ExpropriationHearingRepetition',
  ExpropriationProceedingStarted = 'ExpropriationProceedingStarted',
  ExpropriationProceedingInterupted = 'ExpropriationProceedingInterupted',
  ExpropriationProceedingInteruptionExtended = 'ExpropriationProceedingInteruptionExtended',
  ExpropriationRejected = 'ExpropriationRejected',
  ExpropriationAccepted = 'ExpropriationAccepted',
  ExpropriationAppeal = 'ExpropriationAppeal',
  ExpropriationAppealAccepted = 'ExpropriationAppealAccepted',
  ExpropriationAppealRejected = 'ExpropriationAppealRejected',
  ExpropriationStopped = 'ExpropriationStopped',
  ExpropriationEnforceable = 'ExpropriationEnforceable',
  ExpropriationInterimDecisionRequest = 'ExpropriationInterimDecisionRequest',
  ExpropriationInterimDecision = 'ExpropriationInterimDecision',
  ExpropriationAdministrativeAppeal = 'ExpropriationAdministrativeAppeal',
  ExpropriationAdministrativeAppealRejected = 'ExpropriationAdministrativeAppealRejected',
  ExpropriationAdministrativeAppealAccepted = 'ExpropriationAdministrativeAppealAccepted',
  ExpropriationCompensationPayment = 'ExpropriationCompensationPayment',
  AcceptedGeometricalPlanPossible = 'AcceptedGeometricalPlanPossible',
  MeetingRequest = 'MeetingRequest',
  AllAcceptedGeometricalPlanPossible = 'AllAcceptedGeometricalPlanPossible',
  EntryProposal = 'EntryProposal',
  CadastreEntry = 'CadastreEntry',
  EntryDeclined = 'EntryDeclined',
  PaymentOrder = 'PaymentOrder',
  Cancelled = 'Cancelled',
  PaymentInstruction = 'PaymentInstruction',
  EntryStopped = 'EntryStopped',
  UndeliveredOwner = 'UndeliveredOwner',
  SignedSentOwners = 'SignedSentOwners',
  PersonalVisit = 'PersonalVisit',
  ContractRegisterPublication = 'ContractRegisterPublication',
}
